import { z } from 'zod';

// Event visibility and status enums matching the backend
export const EventVisibility = {
  PUBLIC: 'PUBLIC',
  MEMBERS_ONLY: 'MEMBERS_ONLY',
} as const;

export const EventStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
} as const;

export type EventVisibilityType = keyof typeof EventVisibility;
export type EventStatusType = keyof typeof EventStatus;

// Filter form schema
export const filterFormSchema = z.object({
  venueId: z.string().optional(),
  visibility: z.array(z.enum(['PUBLIC', 'MEMBERS_ONLY'])).optional(),
  status: z.array(z.enum(['DRAFT', 'PUBLISHED'])).optional(),
});

export type FilterFormValues = z.infer<typeof filterFormSchema>;

// Legacy schema (keeping for backwards compatibility if needed)
export const FormSchema = z.object({
  name: z.string().min(2, {
    message: 'A name is required.',
  }),
  // normalize description so empty strings become undefined
  description: z
    .string()
    .optional()
    .transform((val) => (val && val.trim().length ? val.trim() : undefined)),
  capacity: z
    .number()
    .min(1, {
      message: 'Please enter the number of guests',
    })
    .max(1000, {
      message: 'Max capacity is 1000',
    }),
  guestMin: z
    .number()
    .min(1, {
      message: 'Please enter the number of guests',
    })
    .max(1000, {
      message: 'Max guest minimum is 1000',
    }),
  enabled: z.boolean(),
});

export type FormValues = z.infer<typeof FormSchema>;
